import { object, string, mixed } from 'yup';

export const dadosFaleConoscoSchema = (emprestimo) => {
  if (emprestimo) {
    return object({
      nome: string().required('O nome é obrigatório'),
      matricula: string().required('A matrícula é obrigatória'),
      telefone: string(),
      celular: string(),
      assunto: string().required('O assunto é obrigatório'),
      anexoEmprestimo: mixed().required('O arquivo é obrigatório'),
      anexoEmprestimo2: mixed().optional(),
      anexoEmprestimo3: mixed().optional(),
      anexoEmprestimo4: mixed().optional(),
      anexoEmprestimo5: mixed().optional(),
      anexoOutros: mixed().optional(),
    });
  }

  return object({
    nome: string().required('O nome é obrigatório'),
    matricula: string().required('A matrícula é obrigatória'),
    telefone: string(),
    celular: string(),
    assunto: string().required('O assunto é obrigatório'),
    mensagem: string().required('A mensagem de texto é obrigatória'),
    anexoFaleConosco: mixed().optional(),
    anexoEmprestimo2: mixed().optional(),
    anexoEmprestimo3: mixed().optional(),
    anexoEmprestimo4: mixed().optional(),
    anexoEmprestimo5: mixed().optional(),
  });
};
